export type FitMode = 'cover' | 'contain' | 'width' | 'height'

export type ScrollVideoOptions = {
  src?: string | undefined // data-src=""
  frames?: number // data-frames="100"
  webp?: boolean // data-webp="true"
  playbackSpeed?: number // data-playback-speed="10"
  focusPoint?: { x: number; y: number } // data-focus-point="50,50"
  fit?: FitMode // data-fit="cover"
  autoplay?: boolean // data-autoplay="false"
  autoplayDoneAt?: false | number // data-autoplay-done-at="50"
  contents?: {
    element: HTMLElement // On every child:
    showAt: number // data-show-at="0"
    hideAt: number // data-hide-at="100"
    fadeInDuration: number // data-fade-in-duration="20"
    fadeOutDuration: number // data-fade-out-duration="20"
  }[]
}

export type ScrollVideoOptionsFull = {
  [key in keyof ScrollVideoOptions]-?: ScrollVideoOptions[key]
}

export type ScrollVideo = {
  update: (options: ScrollVideoOptions) => void
  destroy: () => void
}
declare global {
  interface HTMLElement {
    scrollVideo(options?: 'destroy' | ScrollVideoOptions): HTMLElement;
  }
}
